import { writable } from 'svelte/store';

let store = writable([]);

export default {
    subscribe: store.subscribe,

    load() {
        return fetch(`/api/surveys`)
        .then(res => {
            if (!res.ok) throw new Error('Oh no');

            return res.json();
        })
        .then(res => {
            let surveys = res.surveys || [];

            // Set date string to Date object
            for (let survey of surveys) {
                survey.sur_from = survey.sur_from ? new Date(survey.sur_from) : null;
                survey.sur_to = survey.sur_to ? new Date(survey.sur_to) : null;
            }

            store.set(surveys);

            return res;
        })
        .catch(e => {
            store.set([]);

            return false;
        });
    },

    setOptions(surId, selected) {
        let form = new FormData();
        form.set('surId', surId);

        for (let suaId in selected) {
            if (!selected.hasOwnProperty(suaId) || !selected[suaId]) continue;

            form.append('suaId[]', suaId);
        }

        return fetch('/api/surveys/set-options', {
            credentials: 'same-origin',
            method: 'POST',
            body: form
        }).then(res => {
            if (!res.ok) throw new Error('User not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    },

    clear() {
        store.set([]);
    }
};